import { SHStack, SHTypography } from "@components/design-systems";
import { MAAnalysisDataDTO } from "@models/managed-accounts/entities/step/fee";
import { memo } from "react";
import { PerformanceNumberCell } from "../../value-renders/performance-number-cell";

interface Props {
  analysisData?: MAAnalysisDataDTO;
}
export const SubGroupSubProductValueCell = memo(({ analysisData }: Props) => {
  const { value, valueInPercent } = analysisData || {};

  return (
    <SHStack
      width={"100%"}
      direction={"row"}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <PerformanceNumberCell
        value={value}
        valueInPercent={valueInPercent}
        valueExcPerf={value}
        valueExcPerfInPercent={valueInPercent}
        forcePercentageDecimalScale={false}
        renderValue={(value: string) => (
          <SHTypography
            variant={"subtitle2"}
            lineHeight={"120%"}
            fontSize={13}
            fontWeight={500}
          >
            {value}
          </SHTypography>
        )}
      />
    </SHStack>
  );
});
